import React from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { Link } from "react-router-dom";
import { DateTime } from "components/common/Date";
import { useGoodsReceiptOverview } from "./GoodsReceiptOverviewContext";

const OverviewTab = () => {
  const { goodsReceipt: record } = useGoodsReceiptOverview();
  if (!record) return null;

  const po = record.purchaseOrder;
  const receiverName = record.receiver
    ? [record.receiver.firstName, record.receiver.lastName]
        .filter(Boolean)
        .join(" ") || record.receiver.email || null
    : null;

  return (
    <Row>
      <Col>
        <Card>
          <CardBody>
            <div className="text-muted">
              <h6 className="mb-3 text-uppercase">Receipt info</h6>
              <div className="table-responsive">
                <Table className="table-borderless mb-0">
                  <tbody>
                    <tr>
                      <th
                        className="ps-0"
                        scope="row"
                        style={{ width: "180px" }}
                      >
                        Code :
                      </th>
                      <td className="text-muted">
                        {record.code ?? `GRN #${record.id}`}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Purchase order :
                      </th>
                      <td className="text-muted">
                        {po?.id ? (
                          <Link
                            to={`/inventory-management/purchase-orders/${po.id}`}
                            className="link fw-medium"
                          >
                            {po.code ?? `PO #${po.id}`}
                          </Link>
                        ) : (
                          "—"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Supplier :
                      </th>
                      <td className="text-muted">
                        {po?.supplier?.id ? (
                          <Link
                            to={`/inventory-management/suppliers/${po.supplier.id}`}
                            className="link fw-medium"
                          >
                            {[po.supplier.code, po.supplier.name]
                              .filter(Boolean)
                              .join(" · ")}
                          </Link>
                        ) : po?.supplier?.name ? (
                          [po.supplier.code, po.supplier.name]
                            .filter(Boolean)
                            .join(" · ")
                        ) : (
                          "—"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Stock location :
                      </th>
                      <td className="text-muted">
                        {record.stockLocation?.name ?? "—"}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Received at :
                      </th>
                      <td className="text-muted">
                        {record.receivedAt ? (
                          <DateTime date={record.receivedAt} />
                        ) : (
                          "—"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Received by :
                      </th>
                      <td className="text-muted">
                        {receiverName ?? "—"}
                      </td>
                    </tr>
                    <tr>
                      <th className="ps-0" scope="row">
                        Notes :
                      </th>
                      <td className="text-muted">{record.notes ?? "—"}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>

              {record.receivedAt ? (
                <div className="pt-3 border-top border-top-dashed mt-4">
                  <Row className="gy-3">
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          Received
                        </p>
                        <h5 className="fs-14 mb-0">
                          <DateTime date={record.receivedAt} />
                        </h5>
                      </div>
                    </Col>
                    {record.stockLocation?.name ? (
                      <Col lg={3} sm={6}>
                        <div>
                          <p className="mb-2 text-uppercase fw-medium">
                            Location
                          </p>
                          <h5 className="fs-14 mb-0 text-muted">
                            {record.stockLocation.name}
                          </h5>
                        </div>
                      </Col>
                    ) : null}
                  </Row>
                </div>
              ) : null}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default OverviewTab;
